<template>
    <div class="headerBox">
          <div class="mlogo" :class="[root.device=='phone'&&'notransform']" @click="goMain"><img  src="@/assets/logoname.png"/></div>
        <div class="left">
            <DvDecoration8 />
        </div>
        
        <div class="txt" @click="fullScreen">
           {{title}}
        </div>
        <Decoration5new :color="['#2E51AE','#070919']" class="line" />
      
        <div class="right">
             <DvDecoration8  :reverse="true" />
        </div>
        <div class="time">{{dateFormat(date)}}</div>
    </div>
</template>

<script>
    import Decoration5new from './datav/decoration5new/main';
    import DvDecoration8 from "./vip/decoration8new/main";

    export default {
        inject:['root'],
        name: 'TopHeader',
        props: {  
            title: {
                type: String,
                default: ""
            },
        },
        data () {
            return {
                date: new Date()
            }
        },
        mounted() {       
            let _this = this;
            this.timer = setInterval(function() {
            _this.date = new Date();
            });
        },
        beforeDestroy: function() {
            if (this.timer) {
            clearInterval(this.timer);
            }
        },
        methods:{
             fullScreen(){
                 document.querySelector("body").requestFullscreen();
                 this.root.device=this.$isMobile()
             },
              goMain(){              
                this.$router.push({
                    name:"main",
                    query:{id:5}
                })
            },
            dateFormat:function(date) {
                var year=date.getFullYear();
                var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
                var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
                var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
                // 拼接
                return year+"年"+month+"月"+day+"日 "+hours+":"+minutes+":"+seconds;
            }
        },
        components: {
            Decoration5new,
            DvDecoration8          
        }
    }
</script>

<style lang="scss" type="text/scss">
   .headerBox{
       display: flex;
       position: relative;
       width: 100%;
        .mlogo{
           position: absolute;
           font-family: PingFangSC-Semibold;
           font-size: 1.15vw;
           color: #4EADFF;
           letter-spacing: 0;
           text-align: right;
           top:20px;
           left: 18px;
           img{
               width:270px;
               height:35px;
           }
           &.notransform{
                top:4px !important;
            img{              
           
                width:90px !important;
                height:auto !important;
            }
           }
       }
       .left{
         flex: 1;
       }
       .right{
            flex: 1;
       }
       .txt{
           width:25%;
           font-size: 2.5vw;
           text-align: center;
           color: #4EADFF;
       }
       .line{
           position: absolute;
         
            top: 56px;
            width: 100%;
            height: 24px;
       }
       .time{
               position: absolute;
            font-family: PingFangSC-Semibold;
            font-size: 22px;
            color: #4EADFF;
            letter-spacing: 0;
            text-align: right;
            top: 26px;
            right: 22px;
       }
   }
   
</style>